<ng-container *ngIf="opened">
	<div
		moveToRoot
		class="backdrop w-100 h-100 pos-fixed pos-t-0 pos-l-0 p-safe border-box bg-backdrop"
		(click)="outsideClick()"
	>
		<div class="w-100 h-100 fl fl-ai-c fl-jc-c ws-pl wb-bw">
			<div
				class="container bg-260 fl fl-dir-c fl-ai-c fl-jc-fs ov-auto shadow-menu p-2-rbl p-1h-t br-1h"
				[style.maxHeight]="warningModal ? (modalHeight ?? 'unset') : '500px'"
				[style.height]="warningModal ? (modalHeight ?? 'unset') : '100%'"
				[style.width]="warningModal && modalWidth ? modalWidth : null"
				(click)="$event.stopPropagation()"
			>
				<div class="w-100 fl m-1h-b" [class.fl-jc-fe]="warningModal">
					<ng-content select="[title]"></ng-content>

					<button
						*ngIf="showClose"
						class="fc-400 fc-800-on-hover p-0h"
						uiNewButtonIcon
						size="SMALL"
						(click)="close()"
					>
						<i class="icon-cross"></i>
					</button>
				</div>
				<div class="fl fl-dir-c fl-adaptable w-100 h-100 ov-auto">
					<ng-content></ng-content>
				</div>

				<ng-content select="[footer]"></ng-content>
			</div>
		</div>
	</div>
</ng-container>
